// main.js - JS application bootstrapper

import { initNavbar } from './components/navbar.js';
import { initScrollAnimations } from './components/scroll-animations.js';
import { initCountUp } from './components/count-up.js';
import { initParallax, initPlatformBgParallax } from './components/parallax.js';
import { initFilter, initLoadMore } from './components/filter.js';
import { initContactForm } from './components/contact-form.js';
import './components/nvsAccessTool.js';


document.addEventListener('DOMContentLoaded', () => {
  initNavbar();
  initScrollAnimations();
  initCountUp();
  initParallax();
  initPlatformBgParallax();
  initFilter();
  initLoadMore();
  initContactForm();

  const stripe = document.querySelector('.partner-stripe');
  const footer = document.querySelector('.footer');
  if (stripe && footer) {
    const updateStripe = () => {
      stripe.classList.toggle('partner-stripe--hidden', footer.getBoundingClientRect().top < window.innerHeight);
    };
    window.addEventListener('scroll', updateStripe, { passive: true });
    updateStripe();
  }
});
